var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.143 0a.6.6 0 01.59.61v1.015h3.535V.609c0-.337.263-.609.59-.609.326 0 .588.272.588.61v1.015h.983c.866 0 1.571.729 1.571 1.625v8.125C11 12.271 10.295 13 9.429 13H1.57C.705 13 0 12.271 0 11.375V3.25c0-.896.705-1.625 1.571-1.625h.983V.609c0-.337.262-.609.589-.609zM9.82 4.875H1.18v6.5a.4.4 0 00.392.406H9.43a.4.4 0 00.392-.406v-6.5z",
    fill: "#A5A7B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon-date.5f43bf5ef47f9c11db569b7ef46235ca.svg";
export { ForwardRef as ReactComponent };